export const SETRETURNREQUESTLIST = "SETRETURNREQUESTLIST";
export const SETRETURNREQUEST = "SETRETURNREQUEST";
export const SETRETURNREQUESTCOUNT = "SETRETURNREQUESTCOUNT";
export const SETRETURNINVOICELIST = "SETRETURNINVOICELIST";
export const SETRETURNINVOICEITEMLIST = "SETRETURNINVOICEITEMLIST";
export const SETRETURNREQUESTADDRESSLIST = "SETRETURNADDRESSLIST";
export const SETSELECTEDINVOICE = "SETSELECTEDINVOICE";
export const SETSTATUSLIST = "SETSTATUSLIST";